(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8849],{

/***/ 82827:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ ToastContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var ToastContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    open: function open(span) {}
});


/***/ }),

/***/ 54213:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ useToast; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _ToastContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82827);


var useToast = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_ToastContext__WEBPACK_IMPORTED_MODULE_1__/* .ToastContext */ .u);
};


/***/ }),

/***/ 78111:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ BuilderDataRender; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./services/utils.js
var utils = __webpack_require__(75681);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/builder/builder.module.scss
var builder_module = __webpack_require__(20426);
var builder_module_default = /*#__PURE__*/__webpack_require__.n(builder_module);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./helper.js
var helper = __webpack_require__(63385);
;// CONCATENATED MODULE: ./components/builder/helpers.ts


var builderRowStylesHandler = function(param) {
    var index = param.index, tab = param.tab, dbName = param.dbName, renderRowBackground = param.renderRowBackground, renderRowAlignItems = param.renderRowAlignItems, renderRowBgImage = param.renderRowBgImage, renderRowBgImageHeight = param.renderRowBgImageHeight;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
    if ((renderRowBackground === null || renderRowBackground === void 0 ? void 0 : (ref = renderRowBackground[0]) === null || ref === void 0 ? void 0 : (ref1 = ref[tab - 1]) === null || ref1 === void 0 ? void 0 : ref1[index]) && (renderRowBackground === null || renderRowBackground === void 0 ? void 0 : (ref2 = renderRowBackground[0]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[tab - 1]) === null || ref3 === void 0 ? void 0 : ref3[index]) !== "transparent" && (renderRowBackground === null || renderRowBackground === void 0 ? void 0 : (ref4 = renderRowBackground[0]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[tab - 1]) === null || ref5 === void 0 ? void 0 : ref5[index]) !== "none") {
        var ref12, ref13, ref14, ref15;
        var ref16;
        return {
            background: renderRowBackground === null || renderRowBackground === void 0 ? void 0 : (ref12 = renderRowBackground[0]) === null || ref12 === void 0 ? void 0 : (ref13 = ref12[tab - 1]) === null || ref13 === void 0 ? void 0 : ref13[index],
            alignItems: (ref16 = renderRowAlignItems === null || renderRowAlignItems === void 0 ? void 0 : (ref14 = renderRowAlignItems[0]) === null || ref14 === void 0 ? void 0 : (ref15 = ref14[tab - 1]) === null || ref15 === void 0 ? void 0 : ref15[index]) !== null && ref16 !== void 0 ? ref16 : "flex-start"
        };
    } else if ((renderRowBgImage === null || renderRowBgImage === void 0 ? void 0 : (ref6 = renderRowBgImage[0]) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[tab - 1]) === null || ref7 === void 0 ? void 0 : ref7[index]) && (renderRowBgImage === null || renderRowBgImage === void 0 ? void 0 : (ref8 = renderRowBgImage[0]) === null || ref8 === void 0 ? void 0 : (ref9 = ref8[tab - 1]) === null || ref9 === void 0 ? void 0 : ref9[index]) !== "none") {
        var ref17, ref18, ref19, ref20, ref21, ref22;
        var ref23;
        return {
            backgroundImage: "url(".concat((0,helper/* domainUrl */.HJ)("".concat(dbName, "/").concat(renderRowBgImage === null || renderRowBgImage === void 0 ? void 0 : (ref17 = renderRowBgImage[0]) === null || ref17 === void 0 ? void 0 : (ref18 = ref17[tab - 1]) === null || ref18 === void 0 ? void 0 : ref18[index])), ")"),
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            minHeight: renderRowBgImageHeight === null || renderRowBgImageHeight === void 0 ? void 0 : (ref19 = renderRowBgImageHeight[0]) === null || ref19 === void 0 ? void 0 : (ref20 = ref19[tab - 1]) === null || ref20 === void 0 ? void 0 : ref20[index],
            display: "flex",
            alignItems: (ref23 = renderRowAlignItems === null || renderRowAlignItems === void 0 ? void 0 : (ref21 = renderRowAlignItems[0]) === null || ref21 === void 0 ? void 0 : (ref22 = ref21[tab - 1]) === null || ref22 === void 0 ? void 0 : ref22[index]) !== null && ref23 !== void 0 ? ref23 : "center"
        };
    }
    var ref24;
    return {
        alignItems: (ref24 = renderRowAlignItems === null || renderRowAlignItems === void 0 ? void 0 : (ref10 = renderRowAlignItems[0]) === null || ref10 === void 0 ? void 0 : (ref11 = ref10[tab - 1]) === null || ref11 === void 0 ? void 0 : ref11[index]) !== null && ref24 !== void 0 ? ref24 : "flex-start"
    };
};
var builderColumnStylesHandler = function(param) {
    var index = param.index, indexCol = param.indexCol, dbName = param.dbName, tab = param.tab, renderColumn = param.renderColumn;
    var ref, ref1;
    var ref2 = (renderColumn === null || renderColumn === void 0 ? void 0 : (ref = renderColumn[tab - 1]) === null || ref === void 0 ? void 0 : (ref1 = ref[index]) === null || ref1 === void 0 ? void 0 : ref1[indexCol]) || {}, columnCol = ref2.backgroundColor, columnImg = ref2.backgroundImage, columnHeight = ref2.bgImageHeight, columnAlignment = ref2.alignItems;
    if (columnCol && columnCol !== "transparent" && columnCol !== "none") {
        return {
            background: columnCol
        };
    } else if (columnImg && columnImg !== "none") {
        var alignItems = {};
        if (columnAlignment && columnAlignment.length > 0) {
            alignItems = {
                display: "flex",
                alignItems: columnAlignment
            };
        }
        return (0,_object_spread/* default */.Z)({
            backgroundImage: "url(".concat((0,helper/* domainUrl */.HJ)("".concat(dbName, "/").concat(columnImg)), ")"),
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            minHeight: columnHeight
        }, alignItems);
    }
    return {};
};

;// CONCATENATED MODULE: ./components/builder/BuilderDataRender.tsx







/*** made dynamic imports for builder components ***/ var Heading = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4817).then(__webpack_require__.bind(__webpack_require__, 24817));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(24817)
            ];
        }
    }
});
var HyperLink = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2723).then(__webpack_require__.bind(__webpack_require__, 52723));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(52723)
            ];
        }
    }
});
var Editor = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7677).then(__webpack_require__.bind(__webpack_require__, 27677));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(27677)
            ];
        }
    }
});
var AccordionComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7357).then(__webpack_require__.bind(__webpack_require__, 97357));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(97357)
            ];
        }
    }
});
var ImageUploadingApp = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(8028)]).then(__webpack_require__.bind(__webpack_require__, 28028));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(28028)
            ];
        }
    }
});
var Button = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2149).then(__webpack_require__.bind(__webpack_require__, 2149));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(2149)
            ];
        }
    }
});
var VideoComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3948).then(__webpack_require__.bind(__webpack_require__, 33948));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(33948)
            ];
        }
    }
});
var BlogsComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(4432), __webpack_require__.e(3997), __webpack_require__.e(9790)]).then(__webpack_require__.bind(__webpack_require__, 49790));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(49790)
            ];
        }
    }
});
var RenderBuilderComponent = function(param) {
    var data = param.data, domain = param.domain, dbName = param.dbName;
    var builderComponents = {
        Heading: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
            item: data
        }),
        HyperLink: /*#__PURE__*/ (0,jsx_runtime.jsx)(HyperLink, {
            item: data
        }),
        Editor: /*#__PURE__*/ (0,jsx_runtime.jsx)(Editor, {
            item: data
        }),
        Accordion: /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionComponent, {
            item: data
        }),
        ImageUpload: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageUploadingApp, {
            item: data,
            dbName: dbName
        }),
        Button: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
            item: data
        }),
        Video: (data === null || data === void 0 ? void 0 : data.fullScreen) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "video_wrapper",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoComponent, {
                item: data
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoComponent, {
            item: data
        }),
        Blogs: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogsComponent, {
            domain: domain,
            item: data
        }),
        Grid: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
    };
    return builderComponents[data === null || data === void 0 ? void 0 : data.content] || /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
var BuilderSection = function(param) {
    var tree = param.tree, tab = param.tab, componentsData = param.componentsData, initialLayout = param.initialLayout, domain = param.domain, dbName = param.dbName;
    var ref;
    var renderClass = (0,utils/* renderMapData */.Lq)(initialLayout, "class");
    var renderRowBackground = (0,utils/* renderMapData */.Lq)(initialLayout, "backgroundColor");
    var renderRowBgImage = (0,utils/* renderMapData */.Lq)(initialLayout, "backgroundImage");
    var renderRowBgImageHeight = (0,utils/* renderMapData */.Lq)(initialLayout, "bgImageHeight");
    var renderBlockAlignItems = (0,utils/* renderMapData */.Lq)(initialLayout, "alignItems");
    var renderRowAlignItems = (0,utils/* renderMapData */.Lq)(initialLayout, "alignItemsRow");
    var renderRowFullScreen = (0,utils/* renderMapData */.Lq)(initialLayout, "fullScreen");
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,utils/* renderMapData */.Lq)(initialLayout, "column") || [], 1), tmp = ref1[0], renderColumn = tmp === void 0 ? [] : tmp;
    var rowStyles = function(index) {
        return builderRowStylesHandler({
            index: index,
            tab: tab,
            dbName: dbName,
            renderRowBgImage: renderRowBgImage,
            renderRowBackground: renderRowBackground,
            renderRowBgImageHeight: renderRowBgImageHeight,
            renderRowAlignItems: renderRowAlignItems
        });
    };
    var columnStyles = function(index, indexCol) {
        return builderColumnStylesHandler({
            index: index,
            indexCol: indexCol,
            tab: tab,
            dbName: dbName,
            renderColumn: renderColumn
        });
    };
    return componentsData && Object.values(componentsData).length > 0 && tree[tab] && Object.values(tree[tab]).length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "block-products",
        style: {
            marginBottom: 0
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "".concat((builder_module_default())["home-product-container"], " ").concat((builder_module_default())["b-container"]),
            children: tree && tab && Array.isArray(tree === null || tree === void 0 ? void 0 : tree[tab]) && ((ref = tree[tab]) === null || ref === void 0 ? void 0 : ref.map(function(item, ind) {
                var ref;
                if ((item === null || item === void 0 ? void 0 : item.length) === 1 && (item === null || item === void 0 ? void 0 : (ref = item[0]) === null || ref === void 0 ? void 0 : ref.length) === 1) {
                    var ref1, ref2;
                    var BuilderComponent = (0,utils/* createBuilderData */.p7)(componentsData, item[0][0]);
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "zg-grid-col zg-col-lg zg-col-sm zg-col-md ".concat(!(renderRowFullScreen === null || renderRowFullScreen === void 0 ? void 0 : (ref1 = renderRowFullScreen[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[tab - 1]) === null || ref2 === void 0 ? void 0 : ref2[ind]) && "container", " ").concat((builder_module_default()).builder_component),
                        // style={rowStyles(ind)}
                        style: {
                            flex: "1, 0"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RenderBuilderComponent, {
                            domain: domain,
                            data: BuilderComponent,
                            dbName: dbName
                        })
                    }, (0,utils/* idGen */["do"])());
                } else {
                    var ref3, ref4;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "zg-row ".concat(!(renderRowFullScreen === null || renderRowFullScreen === void 0 ? void 0 : (ref3 = renderRowFullScreen[0]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[tab - 1]) === null || ref4 === void 0 ? void 0 : ref4[ind]) && "container", " ").concat((builder_module_default()).builder_component),
                        style: rowStyles(ind),
                        children: item === null || item === void 0 ? void 0 : item.map(function(element, index) {
                            if ((element === null || element === void 0 ? void 0 : element.length) === 1) {
                                var ref, ref1, ref2;
                                var BuilderComponent = (0,utils/* createBuilderData */.p7)(componentsData, element[0]);
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat(renderClass === null || renderClass === void 0 ? void 0 : (ref = renderClass[0]) === null || ref === void 0 ? void 0 : (ref1 = ref[tab - 1]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[ind]) === null || ref2 === void 0 ? void 0 : ref2[index], " ").concat((builder_module_default()).builder_component),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RenderBuilderComponent, {
                                        domain: domain,
                                        data: BuilderComponent,
                                        dbName: dbName
                                    })
                                }, (0,utils/* idGen */["do"])());
                            } else {
                                var ref3, ref4, ref5;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: renderClass === null || renderClass === void 0 ? void 0 : (ref3 = renderClass[0]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[tab - 1]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[ind]) === null || ref5 === void 0 ? void 0 : ref5[index],
                                    style: columnStyles(ind, index),
                                    children: element === null || element === void 0 ? void 0 : element.map(function(elInEl) {
                                        var BuilderComponent = (0,utils/* createBuilderData */.p7)(componentsData, elInEl);
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (builder_module_default()).builder_component,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RenderBuilderComponent, {
                                                domain: domain,
                                                data: BuilderComponent,
                                                dbName: dbName
                                            })
                                        }, (0,utils/* idGen */["do"])());
                                    })
                                }, (0,utils/* idGen */["do"])());
                            }
                        })
                    }, (0,utils/* idGen */["do"])());
                }
            }))
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var BuilderDataRender = (/*#__PURE__*/(0,react.memo)(BuilderSection));


/***/ }),

/***/ 68949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26628);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(86896);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(44012);
/* harmony import */ var _helper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63385);
/* harmony import */ var _store_cart__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28286);
/* harmony import */ var _store_token__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46607);
/* harmony import */ var _store_wishlist__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(80225);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _svg__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69587);
/* harmony import */ var _store_general__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26298);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _atoms_Toast_useToast__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(54213);
/* harmony import */ var _services_utils__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(75681);
/* harmony import */ var _product_module_scss__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(30420);
/* harmony import */ var _product_module_scss__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_product_module_scss__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _builder_BuilderDataRender__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(78111);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_14__);



















// @ts-ignore
var AsyncAction = next_dynamic__WEBPACK_IMPORTED_MODULE_10___default()(function() {
    return __webpack_require__.e(/* import() */ 9381).then(__webpack_require__.bind(__webpack_require__, 89381));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(89381)
            ];
        }
    }
});
var InputNumber = next_dynamic__WEBPACK_IMPORTED_MODULE_10___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3997), __webpack_require__.e(8168)]).then(__webpack_require__.bind(__webpack_require__, 48168));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(48168)
            ];
        }
    }
});
var ProductGallery = next_dynamic__WEBPACK_IMPORTED_MODULE_10___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(1190), __webpack_require__.e(3997), __webpack_require__.e(6705), __webpack_require__.e(6917)]).then(__webpack_require__.bind(__webpack_require__, 86705));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(86705)
            ];
        }
    }
});
var SMSharedButton = next_dynamic__WEBPACK_IMPORTED_MODULE_10___default()(function() {
    return __webpack_require__.e(/* import() */ 1922).then(__webpack_require__.bind(__webpack_require__, 61922));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61922)
            ];
        }
    }
});
var Prices = next_dynamic__WEBPACK_IMPORTED_MODULE_10___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3997), __webpack_require__.e(4374)]).then(__webpack_require__.bind(__webpack_require__, 7778));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7778)
            ];
        }
    }
});
var WishIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_10___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3997), __webpack_require__.e(5065)]).then(__webpack_require__.bind(__webpack_require__, 75714));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(75714)
            ];
        }
    }
});
var Details = next_dynamic__WEBPACK_IMPORTED_MODULE_10___default()(function() {
    return __webpack_require__.e(/* import() */ 4595).then(__webpack_require__.bind(__webpack_require__, 4595));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4595)
            ];
        }
    }
});
var SimpleProduct = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20;
    var token = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state.cartToken;
    });
    var customer = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state.customer;
    });
    var bOrder = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state.general.Backorders;
    });
    var signed = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state.customer.authenticated;
    });
    var wishlist = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state.wishlist;
    });
    var backorders = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state.general.Backorders;
    });
    var currencyCode = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state.rate.current.code;
    });
    var rate = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state.rate.exchange_rate.rate;
    });
    var phone = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        var ref;
        return (ref = state.general.coreConfigs.general_info_general_phone) === null || ref === void 0 ? void 0 : ref.value;
    });
    var general_info_general_phone = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state.general.coreConfigs.general_info_general_phone;
    });
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
    var toast = (0,_atoms_Toast_useToast__WEBPACK_IMPORTED_MODULE_11__/* .useToast */ .p)();
    var ref21 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(props.productData), product = ref21[0], setProduct = ref21[1];
    var ref22 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isSelectDetail = ref22[0], setIsSelectDetail = ref22[1];
    var details = props.productData.details;
    var checkAddProd = false;
    var ref23 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isMobile = ref23[0], setIsMobile = ref23[1];
    var windowSize = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state.general.windowSize;
    });
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)();
    var ref24 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), phoneNumber = ref24[0], setPhoneNumber = ref24[1];
    // const [hasPhoneNumber, setHasPhoneNumber] = useState(false)
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!windowSize) dispatch((0,_store_general__WEBPACK_IMPORTED_MODULE_9__/* .setWindowSize */ .QC)(window.innerWidth));
        setIsMobile(windowSize <= 576);
    }, [
        windowSize
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setPhoneNumber(phone);
    }, [
        phone
    ]);
    // useEffect(() => {
    //     if(props.translations.hasOwnProperty("phone_number_service_theme")){
    //         setHasPhoneNumber(true)
    //         setPhoneNumber(intl.formatMessage({id: 'phone_number_service_theme'}))
    //     }else setHasPhoneNumber(false)
    // }, [])
    var findLocale = function(attr) {
        var ref;
        return attr === null || attr === void 0 ? void 0 : (ref = attr.translations) === null || ref === void 0 ? void 0 : ref.find(function(el) {
            return el.locale === props.locale;
        });
    };
    var createMarkup = function(item) {
        return {
            __html: item
        };
    };
    var skuName = findLocale(product === null || product === void 0 ? void 0 : product.sku_option[0]);
    var description = findLocale(product === null || product === void 0 ? void 0 : product.description_option[0]);
    var short_description = findLocale(product === null || product === void 0 ? void 0 : product.short_description_option[0]);
    var shortDescr = createMarkup((0,_services_utils__WEBPACK_IMPORTED_MODULE_12__/* .replaceDescr */ .lz)((ref = product === null || product === void 0 ? void 0 : product.product_flat[0]) === null || ref === void 0 ? void 0 : ref.short_description));
    var descr = createMarkup((0,_services_utils__WEBPACK_IMPORTED_MODULE_12__/* .replaceDescr */ .lz)((ref1 = product === null || product === void 0 ? void 0 : product.product_flat[0]) === null || ref1 === void 0 ? void 0 : ref1.description));
    var ref25 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        quantity: 1,
        imagesData: null,
        simpleProduct: null,
        token: token,
        productSlug: props.productSlug,
        customer: customer,
        wishlist: wishlist,
        IsOpen: (_product_module_scss__WEBPACK_IMPORTED_MODULE_16___default()["product-inner-long-description-click"])
    }), defState = ref25[0], setDefState = ref25[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setProduct(props.productData);
        checkAddProd = true;
        setDefState((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)({}, defState), {
            // @ts-ignore
            product: props.productData,
            productSlug: props.productSlug,
            imagesData: props.productData.product_images
        }));
        // dispatch(AddImages(props.product.product_images));
        setProduct(props.productData);
        if (defState.token.cartToken === "") {
            ////////FIXME SHOW CHECK FROM STATE BEFORE FETCH
            // @ts-ignore
            fetch("/api/checkout/cart/token").then(function(responce) {
                return responce.json();
            }).then(function(res) {
                if (res.api_token) {
                    dispatch((0,_store_token__WEBPACK_IMPORTED_MODULE_5__/* .AddCartToken */ .y)(res.api_token));
                }
            }).catch(function(err) {
                return console.error(err);
            });
        }
    }, [
        props.change
    ]);
    var handleChangeQuantity = function(quantity) {
        setDefState((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)({}, defState), {
            quantity: quantity
        }));
    };
    var addToast = function(product) {
        //@ts-ignore
        toast.open(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
            className: "d-flex chek-fms",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg__WEBPACK_IMPORTED_MODULE_8__/* .CheckToastSvg */ .xQ, {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                    id: "added_to_cart_toast",
                    defaultMessage: 'Product "'.concat(product === null || product === void 0 ? void 0 : product.product_flat[0].name, '" added to cart')
                })
            ]
        }));
    };
    // checking is product in stock
    var isProductInStock = function(product) {
        var qty = product === null || product === void 0 ? void 0 : product.product_inventories[0].qty;
        return Number(qty) > 0 || Number(qty) === 0 && backorders;
    };
    var addcart = ((ref2 = product === null || product === void 0 ? void 0 : product.product_flat[0]) === null || ref2 === void 0 ? void 0 : ref2.has_up_sell) == 0 && ((ref3 = product === null || product === void 0 ? void 0 : product.product_flat[0]) === null || ref3 === void 0 ? void 0 : ref3.has_cross_sell) == 0;
    var onlyCross = ((ref4 = product === null || product === void 0 ? void 0 : product.product_flat[0]) === null || ref4 === void 0 ? void 0 : ref4.has_up_sell) == 0 && ((ref5 = product === null || product === void 0 ? void 0 : product.product_flat[0]) === null || ref5 === void 0 ? void 0 : ref5.has_cross_sell) == 1;
    var openUpCrossProd = function(product) {
        var ref, ref1;
        // @ts-ignore
        var hasUpSell = ((ref = product === null || product === void 0 ? void 0 : product.product_flat[0]) === null || ref === void 0 ? void 0 : ref.has_up_sell) == 1;
        var hasCrossSell = ((ref1 = product === null || product === void 0 ? void 0 : product.product_flat[0]) === null || ref1 === void 0 ? void 0 : ref1.has_cross_sell) == 1;
        var page = true;
        if (!hasUpSell && hasCrossSell) {
            dispatch((0,_store_cart__WEBPACK_IMPORTED_MODULE_4__/* .getUpOrCrossProd */ .xM)(product.id, "crossSell", props.locale, currencyCode, rate, page));
            dispatch((0,_store_general__WEBPACK_IMPORTED_MODULE_9__/* .setPopupName */ .Sq)("crossSell"));
        }
        if (hasUpSell) {
            dispatch((0,_store_general__WEBPACK_IMPORTED_MODULE_9__/* .setPopupName */ .Sq)("upsell"));
            dispatch((0,_store_cart__WEBPACK_IMPORTED_MODULE_4__/* .getUpOrCrossProd */ .xM)(product.id, "upSell", props.locale, currencyCode, rate, page));
        }
    };
    var _layout = props.layout, layout = _layout === void 0 ? "standard" : _layout, dbName = props.dbName, productSlug = props.productSlug, domain = props.domain;
    var quantity = defState.quantity;
    var maxQty = bOrder ? 50000 : (ref6 = product === null || product === void 0 ? void 0 : product.product_inventories[0]) === null || ref6 === void 0 ? void 0 : ref6.qty;
    var addToCartDisabled = bOrder ? "" : "disabled";
    var componentsData = (props === null || props === void 0 ? void 0 : (ref7 = props.getBuilderData) === null || ref7 === void 0 ? void 0 : (ref8 = ref7[0]) === null || ref8 === void 0 ? void 0 : ref8.components) || {};
    var tree = props === null || props === void 0 ? void 0 : (ref9 = props.getBuilderData) === null || ref9 === void 0 ? void 0 : (ref10 = ref9[0]) === null || ref10 === void 0 ? void 0 : ref10.tree;
    var initialLayout = (props === null || props === void 0 ? void 0 : (ref11 = props.getBuilderData) === null || ref11 === void 0 ? void 0 : (ref12 = ref11[0]) === null || ref12 === void 0 ? void 0 : ref12.initialLayout) || {};
    var drawProducts = function(product, title, type) {
        if (title === "builder1") {
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_builder_BuilderDataRender__WEBPACK_IMPORTED_MODULE_13__["default"], {
                    tree: tree,
                    componentsData: componentsData,
                    tab: 1,
                    initialLayout: initialLayout,
                    dbName: dbName,
                    domain: domain
                });
            }
        } else if (title === "builder2") {
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_builder_BuilderDataRender__WEBPACK_IMPORTED_MODULE_13__["default"], {
                    tree: tree,
                    componentsData: componentsData,
                    tab: 2,
                    initialLayout: initialLayout,
                    dbName: dbName,
                    domain: domain
                });
            }
        } else if (title === "builder3") {
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_builder_BuilderDataRender__WEBPACK_IMPORTED_MODULE_13__["default"], {
                    tree: tree,
                    componentsData: componentsData,
                    tab: 3,
                    initialLayout: initialLayout,
                    dbName: dbName,
                    domain: domain
                });
            }
        }
    };
    var addAndRemoveWishList = function() {
        var wishlistChekArray = wishlist === null || wishlist === void 0 ? void 0 : wishlist.find(function(x) {
            return x.id == (product === null || product === void 0 ? void 0 : product.id);
        });
        if (wishlistChekArray == undefined) {
            var ref;
            //@ts-ignore
            toast.open(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                className: "d-flex chek-fms",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg__WEBPACK_IMPORTED_MODULE_8__/* .CheckToastSvg */ .xQ, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                        id: "added_to_wishlist_toast",
                        defaultMessage: 'Product "'.concat((ref = product === null || product === void 0 ? void 0 : product.product_flat[0]) === null || ref === void 0 ? void 0 : ref.name, '" added to wish list')
                    })
                ]
            }));
        } else {
            var ref1;
            // @ts-ignore
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AsyncAction, {
                // @ts-ignore
                action: dispatch((0,_store_wishlist__WEBPACK_IMPORTED_MODULE_6__/* .wishlistRemoveItem */ .uv)(product === null || product === void 0 ? void 0 : product.id))
            });
            //@ts-ignore
            toast.open(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                className: "d-flex chek-fms",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg__WEBPACK_IMPORTED_MODULE_8__/* .CheckToastSvg */ .xQ, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                        id: "removed_from_wishlist_toast",
                        defaultMessage: 'The product "'.concat((ref1 = product === null || product === void 0 ? void 0 : product.product_flat[0]) === null || ref1 === void 0 ? void 0 : ref1.name, '" was successfully removed from the whishlist')
                    })
                ]
            }));
        }
    };
    var schemaProduct = {
        "@context": "".concat(_helper__WEBPACK_IMPORTED_MODULE_3__/* .url */ .HQ, "/").concat((ref13 = product === null || product === void 0 ? void 0 : product.product_flat[0]) === null || ref13 === void 0 ? void 0 : ref13.url_key),
        "@type": "Product",
        name: (ref14 = product === null || product === void 0 ? void 0 : product.product_flat[0]) === null || ref14 === void 0 ? void 0 : ref14.name,
        description: ((ref15 = product === null || product === void 0 ? void 0 : product.product_flat[0]) === null || ref15 === void 0 ? void 0 : ref15.meta_description) && ((ref16 = product === null || product === void 0 ? void 0 : product.product_flat[0]) === null || ref16 === void 0 ? void 0 : ref16.description),
        image: "https://".concat(dbName, "/storage/").concat((ref17 = product === null || product === void 0 ? void 0 : product.product_images[0]) === null || ref17 === void 0 ? void 0 : ref17.path),
        brand: {
            "@type": "Brand",
            name: "Zega",
            logo: "".concat(_helper__WEBPACK_IMPORTED_MODULE_3__/* .url */ .HQ, "/storage/zega/configuration/logo/logo.webp")
        },
        "review": {
            "@type": "Review",
            name: "Zega"
        },
        productID: product === null || product === void 0 ? void 0 : product.id,
        sku: (ref18 = product === null || product === void 0 ? void 0 : product.product_flat[0]) === null || ref18 === void 0 ? void 0 : ref18.sku
    };
    // const addToCart = (
    //     <div
    //         className={classNames(`${cls["product__actions-item"]} ${cls["product__actions-item--addToCart"]}`, {
    //             [cls["button_disabled"]]: !isProductInStock(product)
    //         })}
    //     >
    //         {
    //             addcart ?
    //                 (
    //                     <AsyncAction
    //                         // @ts-ignore
    //                         action={() => dispatch(cartAddItem(product, [], quantity, token, customer, props.locale,))}
    //
    //                         // @ts-ignore
    //                         render={({run, loading}) => (<button
    //                             type="button"
    //
    //                             onClick={() => {
    //                                 dispatch(setCrossValid(false));
    //                                 run();
    //                                 addToast(product)
    //                             }}
    //                             // @ts-ignore
    //                             // disabled={addToCartDisabled}
    //                             className={classNames(`btn btn-orange ${cls["inner-addToCart"]} ${cls["rounded-pills"]} btn-lg btn-primary`, {
    //                                 "btn-loading": loading,
    //                             })}
    //                         >
    //                             <FormattedMessage
    //                                 id="add_to_cart"
    //                                 defaultMessage="Add to cart"
    //                             />
    //                         </button>)}
    //                     />
    //                 ) :
    //                 onlyCross ?
    //                     (
    //                         <AsyncAction
    //                             // @ts-ignore
    //                             action={() => dispatch(cartAddItem(product, [], quantity, token, customer, props.locale))}
    //                             // @ts-ignore
    //                             render={({run, loading}) => (<button
    //                                 type="button"
    //                                 onClick={() => {
    //                                     run();
    //                                     dispatch(setTempData([product]));
    //                                     dispatch(setPopup(true));
    //                                     dispatch(setCrossValid(true));
    //                                     openUpCrossProd(product);
    //                                     addToast(product)
    //                                 }}
    //                                 // @ts-ignore
    //                                 // disabled={addToCartDisabled}
    //                                 className={classNames(`btn btn-orange ${cls["inner-addToCart"]} ${cls["rounded-pills"]} btn-lg`, {
    //                                     "btn-loading": loading,
    //                                 })}
    //                             >
    //                                 <FormattedMessage
    //                                     id="add_to_cart"
    //                                     defaultMessage="Add to cart"
    //                                 />
    //                             </button>)}
    //                         />
    //                     ) : (
    //                         <AsyncAction
    //                             // @ts-ignore
    //
    //                             render={({run, loading}) => (<button
    //                                 type="button"
    //
    //                                 onClick={() => {
    //                                     run();
    //                                     dispatch(setTempData([product]));
    //                                     dispatch(setPopup(true));
    //                                     dispatch(setCrossValid(false));
    //                                     openUpCrossProd(product);
    //                                 }}
    //                                 // @ts-ignore
    //                                 // disabled={addToCartDisabled}
    //                                 className={classNames(`btn btn-orange ${cls["inner-addToCart"]} ${cls["rounded-pills"]} btn-lg`, {
    //                                     "btn-loading": loading,
    //                                 })}
    //                             >
    //                                 <FormattedMessage
    //                                     id="add_to_cart"
    //                                     defaultMessage="Add to cart"
    //                                 />
    //                             </button>)}
    //                         />
    //                     )}
    //     </div>
    // );
    var selectTab = function(e) {
        setIsSelectDetail(e.target.id === "detail");
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_7___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify(schemaProduct)
                    }
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    drawProducts("builder1", "builder1", "builder"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_product_module_scss__WEBPACK_IMPORTED_MODULE_16___default().product__content),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProductGallery, {
                                // @ts-ignore
                                layout: layout,
                                images: product === null || product === void 0 ? void 0 : product.product_images,
                                imageName: (ref19 = product === null || product === void 0 ? void 0 : product.product_flat[0]) === null || ref19 === void 0 ? void 0 : ref19.name,
                                locale: props.locale
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_product_module_scss__WEBPACK_IMPORTED_MODULE_16___default().product__info),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                        style: {
                                            textAlign: "left"
                                        },
                                        className: (_product_module_scss__WEBPACK_IMPORTED_MODULE_16___default().product__name),
                                        dangerouslySetInnerHTML: createMarkup((ref20 = product === null || product === void 0 ? void 0 : product.product_flat[0]) === null || ref20 === void 0 ? void 0 : ref20.name)
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: (_product_module_scss__WEBPACK_IMPORTED_MODULE_16___default()["product-inner-description-title"]),
                                                children: short_description ? short_description.name : ""
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                style: {
                                                    fontSize: "16px"
                                                },
                                                dangerouslySetInnerHTML: shortDescr
                                            })
                                        ]
                                    }),
                                    !isMobile ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_product_module_scss__WEBPACK_IMPORTED_MODULE_16___default().product__sidebar),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("form", {
                                            className: (_product_module_scss__WEBPACK_IMPORTED_MODULE_16___default().product__options),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "form-group ".concat((_product_module_scss__WEBPACK_IMPORTED_MODULE_16___default().product__option)),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: (_product_module_scss__WEBPACK_IMPORTED_MODULE_16___default().product__actions),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "".concat((_product_module_scss__WEBPACK_IMPORTED_MODULE_16___default()["product__actions-item"]), " ").concat((_product_module_scss__WEBPACK_IMPORTED_MODULE_16___default()["product__actions-item--addToCart"]), " "),
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_14___default()), {
                                                            href: "tel:".concat((phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.includes("+")) ? phoneNumber : "+" + phoneNumber),
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                className: "btn btn-orange ".concat((_product_module_scss__WEBPACK_IMPORTED_MODULE_16___default()["inner-addToCart"]), " ").concat((_product_module_scss__WEBPACK_IMPORTED_MODULE_16___default()["rounded-pills"]), " btn-lg btn-primary"),
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                                                    id: "booking_now_service_theme",
                                                                    defaultMessage: "Booking now"
                                                                })
                                                            })
                                                        })
                                                    })
                                                })
                                            })
                                        })
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("form", {
                                                className: (_product_module_scss__WEBPACK_IMPORTED_MODULE_16___default().product__options),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "form-group ".concat((_product_module_scss__WEBPACK_IMPORTED_MODULE_16___default().product__option)),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: (_product_module_scss__WEBPACK_IMPORTED_MODULE_16___default().product__actions),
                                                        style: {
                                                            display: "flex",
                                                            justifyContent: "space-between"
                                                        },
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "".concat((_product_module_scss__WEBPACK_IMPORTED_MODULE_16___default()["product__actions-item"]), " ").concat((_product_module_scss__WEBPACK_IMPORTED_MODULE_16___default()["product__actions-item--addToCart"]), " "),
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_14___default()), {
                                                                href: "tel:".concat((phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.includes("+")) ? phoneNumber : "+" + phoneNumber),
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                    className: "btn btn-orange ".concat((_product_module_scss__WEBPACK_IMPORTED_MODULE_16___default()["inner-addToCart"]), " ").concat((_product_module_scss__WEBPACK_IMPORTED_MODULE_16___default()["rounded-pills"]), " btn-lg btn-primary"),
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                                                        id: "booking_now_service_theme",
                                                                        defaultMessage: "Booking now"
                                                                    })
                                                                })
                                                            })
                                                        })
                                                    })
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_product_module_scss__WEBPACK_IMPORTED_MODULE_16___default().socialLinksBox),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SMSharedButton, {
                                            url: "https://".concat(dbName, "/products/").concat(productSlug)
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    drawProducts("builder2", "builder2", "builder"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "".concat((_product_module_scss__WEBPACK_IMPORTED_MODULE_16___default().tab_buttons), " ").concat(!(0,_services_utils__WEBPACK_IMPORTED_MODULE_12__/* .checkDetail */ .V_)(details) && (_product_module_scss__WEBPACK_IMPORTED_MODULE_16___default().only_one), " "),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: isSelectDetail ? "".concat((_product_module_scss__WEBPACK_IMPORTED_MODULE_16___default().tab), " ").concat((_product_module_scss__WEBPACK_IMPORTED_MODULE_16___default().tab_description)) : "".concat((_product_module_scss__WEBPACK_IMPORTED_MODULE_16___default().tab), " ").concat((_product_module_scss__WEBPACK_IMPORTED_MODULE_16___default().tab_description), " ").concat((_product_module_scss__WEBPACK_IMPORTED_MODULE_16___default()["tab_description-active"])),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "".concat((_product_module_scss__WEBPACK_IMPORTED_MODULE_16___default()["product-inner-description-title"])),
                                    onClick: selectTab,
                                    children: (description === null || description === void 0 ? void 0 : description.name) || ""
                                })
                            }),
                            (0,_services_utils__WEBPACK_IMPORTED_MODULE_12__/* .checkDetail */ .V_)(details) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: isSelectDetail ? "".concat((_product_module_scss__WEBPACK_IMPORTED_MODULE_16___default().tab), " ").concat((_product_module_scss__WEBPACK_IMPORTED_MODULE_16___default().tab_detail), " ").concat((_product_module_scss__WEBPACK_IMPORTED_MODULE_16___default()["tab_detail-active"])) : "".concat((_product_module_scss__WEBPACK_IMPORTED_MODULE_16___default().tab), " ").concat((_product_module_scss__WEBPACK_IMPORTED_MODULE_16___default().tab_detail)),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_product_module_scss__WEBPACK_IMPORTED_MODULE_16___default()["product-inner-description-title"]),
                                    id: "detail",
                                    onClick: selectTab,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                        id: "details",
                                        defaultMessage: "details"
                                    })
                                })
                            })
                        ]
                    }),
                    isSelectDetail ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Details, {
                        details: details
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_product_module_scss__WEBPACK_IMPORTED_MODULE_16___default()["product-inner-long-description"]),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            style: {
                                paddingLeft: "30px"
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                dangerouslySetInnerHTML: descr
                            })
                        })
                    }),
                    drawProducts("builder3", "builder3", "builder")
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (SimpleProduct);


/***/ }),

/***/ 68849:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ shop_ShopPageProduct; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(26628);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(44012);
// EXTERNAL MODULE: ./services/utils.js
var utils = __webpack_require__(75681);
;// CONCATENATED MODULE: ./data/shopWidgetCategories.js
/* harmony default export */ var shopWidgetCategories = ([
    {
        id: 1,
        name: "Power Tools",
        url: "",
        children: [
            {
                id: 2,
                name: "Engravers",
                url: ""
            },
            {
                id: 3,
                name: "Drills",
                url: ""
            },
            {
                id: 4,
                name: "Wrenches",
                url: ""
            },
            {
                id: 5,
                name: "Plumbing",
                url: ""
            },
            {
                id: 6,
                name: "Wall Chaser",
                url: ""
            },
            {
                id: 7,
                name: "Pneumatic Tools",
                url: ""
            },
            {
                id: 8,
                name: "Milling Cutters",
                url: ""
            }, 
        ]
    },
    {
        id: 9,
        name: "Hand Tools",
        url: "",
        children: [
            {
                id: 10,
                name: "Screwdrivers",
                url: ""
            },
            {
                id: 11,
                name: "Handsaws",
                url: ""
            },
            {
                id: 12,
                name: "Knives",
                url: ""
            },
            {
                id: 13,
                name: "Axes",
                url: ""
            },
            {
                id: 14,
                name: "Multitools",
                url: ""
            },
            {
                id: 15,
                name: "Paint Tools",
                url: ""
            }, 
        ]
    },
    {
        id: 16,
        name: "Garden Equipment",
        url: "",
        children: [
            {
                id: 17,
                name: "Motor Pumps",
                url: ""
            },
            {
                id: 18,
                name: "Chainsaws",
                url: ""
            },
            {
                id: 19,
                name: "Electric Saws",
                url: ""
            },
            {
                id: 20,
                name: "Brush Cutters",
                url: ""
            }, 
        ]
    },
    {
        id: 21,
        name: "Machine Tools",
        url: "",
        children: [
            {
                id: 22,
                name: "Thread Cutting",
                url: ""
            },
            {
                id: 23,
                name: "Chip Blowers",
                url: ""
            },
            {
                id: 24,
                name: "Sharpening Machines",
                url: ""
            },
            {
                id: 25,
                name: "Pipe Cutters",
                url: ""
            },
            {
                id: 26,
                name: "Slotting machines",
                url: ""
            },
            {
                id: 27,
                name: "Lathes",
                url: ""
            }, 
        ]
    },
    {
        id: 28,
        name: "Instruments",
        url: "",
        children: [
            {
                id: 29,
                name: "Welding Equipment",
                url: ""
            },
            {
                id: 30,
                name: "Power Tools",
                url: ""
            },
            {
                id: 31,
                name: "Hand Tools",
                url: ""
            },
            {
                id: 32,
                name: "Measuring Tool",
                url: ""
            }, 
        ]
    },
    {
        id: 33,
        name: "Workbenches",
        url: ""
    },
    {
        id: 34,
        name: "Presses",
        url: ""
    },
    {
        id: 35,
        name: "Spray Guns",
        url: ""
    },
    {
        id: 36,
        name: "Riveters",
        url: ""
    }, 
]);

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./components/shared/products/SimpleProduct.tsx
var SimpleProduct = __webpack_require__(68949);
;// CONCATENATED MODULE: ./components/shared/products/VirtualProduct.tsx



var VirtualProduct = function(param) {
    var product = param.product, layout = param.layout, productSlug = param.productSlug, dbName = param.dbName, rate = param.rate, locale = param.locale, change = param.change, getBuilderData = param.getBuilderData;
    // TODO !!! change this component, when we will have virtual cart product
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleProduct["default"], {
        productData: product,
        layout: layout,
        productSlug: productSlug,
        dbName: dbName,
        rate: rate,
        locale: locale,
        change: change,
        getBuilderData: getBuilderData
    });
};
/* harmony default export */ var products_VirtualProduct = (VirtualProduct);

// EXTERNAL MODULE: ./components/shop/shop.module.scss
var shop_module = __webpack_require__(97550);
var shop_module_default = /*#__PURE__*/__webpack_require__.n(shop_module);
;// CONCATENATED MODULE: ./components/shop/ShopPageProduct.tsx










var WidgetCategories = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5440).then(__webpack_require__.bind(__webpack_require__, 15440));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(15440)
            ];
        }
    }
});
var BlockProductsCarousel = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4428).then(__webpack_require__.bind(__webpack_require__, 84428));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(84428)
            ];
        }
    }
});
var PageHeader = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3997), __webpack_require__.e(5671)]).then(__webpack_require__.bind(__webpack_require__, 64465));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(64465)
            ];
        }
    }
});
var ShopPageProduct_SimpleProduct = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 68949));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(68949)
            ];
        }
    }
});
var ConfigProduct = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3787).then(__webpack_require__.bind(__webpack_require__, 63787));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(63787)
            ];
        }
    }
});
// @ts-ignore
var BundleProduct = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8868).then(__webpack_require__.bind(__webpack_require__, 8868));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(8868)
            ];
        }
    }
});
var ShopPageProduct = function(props) {
    var renderSwitch = function renderSwitch(product) {
        switch(product.type){
            case "simple":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ShopPageProduct_SimpleProduct, {
                    productData: product,
                    layout: layout,
                    productSlug: productSlug,
                    dbName: dbName,
                    rate: props.rate,
                    locale: locale,
                    change: change,
                    getBuilderData: getBuilderData,
                    translations: translations
                });
            case "configurable":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfigProduct, {
                    productData: productData,
                    layout: layout,
                    productSlug: productSlug,
                    locale: locale,
                    configurableVariantes: configurableVariantes || null,
                    dbName: dbName,
                    rate: rate,
                    filtered: filtered,
                    setFiltered: setFiltered,
                    change: change,
                    getBuilderData: getBuilderData,
                    translations: translations
                });
            case "bundle":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(BundleProduct, {
                    // @ts-ignore
                    productData: product,
                    layout: layout,
                    productSlug: productSlug,
                    locale: locale,
                    bundle: bundle,
                    dbName: dbName,
                    rate: props.rate,
                    relatedProducts: relatedProducts,
                    change: change,
                    // props
                    getBuilderData: getBuilderData,
                    translations: translations
                });
            case "virtual":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(products_VirtualProduct, {
                    product: product,
                    layout: layout,
                    productSlug: productSlug,
                    dbName: dbName,
                    rate: props.rate,
                    locale: locale,
                    change: change,
                    getBuilderData: getBuilderData,
                    translations: translations
                });
            default:
                return "foo";
        }
    };
    var ref, ref1;
    var productSlug = props.productSlug, _layout = props.layout, layout = _layout === void 0 ? "standard" : _layout, productData = props.productData, changes = props.changes, _sidebarPosition = props.sidebarPosition, sidebarPosition = _sidebarPosition === void 0 ? "start" : _sidebarPosition, loading = props.loading, bundle = props.bundle, dbName = props.dbName, relProduct = props.relProduct, rate = props.rate, configurableVariantes = props.configurableVariantes, currencies = props.currencies, locale = props.locale, getBuilderData = props.getBuilderData, translations = props.translations;
    var ref2 = (0,react.useState)(loading), isLoading = ref2[0], setIsLoading = ref2[1];
    var router = (0,next_router.useRouter)();
    var ref3 = (0,react.useState)(productData), product = ref3[0], setProduct = ref3[1];
    var ref4 = (0,react.useState)(changes), change = ref4[0], setChange = ref4[1];
    var ref5 = (0,react.useState)(relProduct), relatedProducts = ref5[0], setRelatedProducts = ref5[1];
    var customer = (0,es/* useSelector */.v9)(function(state) {
        return state === null || state === void 0 ? void 0 : state.customer;
    });
    var currency = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return state === null || state === void 0 ? void 0 : (ref = state.rate) === null || ref === void 0 ? void 0 : ref.current.code;
    });
    var selectedData = locale;
    var prevProductSlugRef = (0,react.useRef)();
    var prevLocaleRef = (0,react.useRef)();
    var ref6 = (0,react.useState)({}), filtered = ref6[0], setFiltered = ref6[1];
    (0,react.useEffect)(function() {
        prevProductSlugRef.current = productSlug;
        // prevLocaleRef.current = locale
        setRelatedProducts(relProduct);
        setProduct(productData);
        setChange(!change);
    }, [
        changes
    ]);
    var breadcrumb = [
        {
            title: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                id: "home",
                defaultMessage: "Home"
            }),
            url: "https://".concat(dbName, "/")
        },
        {
            title: (ref = product.product_flat) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.name,
            url: "https://".concat(dbName).concat(utils/* url.product */.HQ.product(product))
        }, 
    ];
    var related = /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
        id: "related_products",
        defaultMessage: "Related products"
    });
    var content;
    if (layout === "sidebar") {
        var sidebar = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (shop_module_default())["shop-layout__sidebar"],
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (shop_module_default()).block,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (shop_module_default())["block-sidebar__item"],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WidgetCategories, {
                            categories: shopWidgetCategories,
                            location: "shop"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((shop_module_default())["block-sidebar__item"], " ").concat((shop_module_default())["d-none"])
                    })
                ]
            })
        });
        content = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "container",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((shop_module_default())["shop-layout"], " ").concat((shop_module_default())["shop-layout--sidebar--".concat(sidebarPosition)]),
                children: [
                    sidebarPosition === "start" && sidebar,
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (shop_module_default())["shop-layout__content"],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (shop_module_default()).block,
                                children: renderSwitch(product)
                            }),
                            Object.keys(relatedProducts).length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockProductsCarousel, {
                                title: related,
                                layout: "grid-4-sm",
                                products: Object.values(relatedProducts),
                                locale: router.locale,
                                change: change,
                                dbName: dbName
                            })
                        ]
                    }),
                    sidebarPosition === "end" && sidebar
                ]
            })
        });
    } else {
        content = /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (shop_module_default()).block,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container",
                        children: renderSwitch(product)
                    })
                }),
                Object.keys(relatedProducts).length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockProductsCarousel, {
                    customer: customer,
                    title: related,
                    layout: "grid-5",
                    products: Object.values(relatedProducts),
                    locale: router.locale,
                    change: change,
                    dbName: dbName
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageHeader, {
                breadcrumb: breadcrumb
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: content
            })
        ]
    });
};
/* harmony default export */ var shop_ShopPageProduct = (ShopPageProduct);


/***/ }),

/***/ 20426:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card-faq":"builder_card-faq___8Hjc","rc-accordion-card":"builder_rc-accordion-card__SoU6T","rc-accordion-toggle":"builder_rc-accordion-toggle__l_bh4","active":"builder_active__z0l8Z","rc-accordion-icon":"builder_rc-accordion-icon__5UnOD","rc-accordion-title":"builder_rc-accordion-title__HMLEs","rc-collapse":"builder_rc-collapse__5BWI3","show":"builder_show__JxzY2","rc-accordion-body":"builder_rc-accordion-body__G4F_R","b-container":"builder_b-container__iumtw","zg-grid-col":"builder_zg-grid-col__HDyvd","zg-row":"builder_zg-row__hLWu7","zg-dragforborder":"builder_zg-dragforborder__akYEv","builder_component":"builder_builder_component__f722A","zg-col-lg":"builder_zg-col-lg__H9V0R","zg-col-md":"builder_zg-col-md__vIYqG","zg-col-sm":"builder_zg-col-sm__lV4MC"};

/***/ }),

/***/ 30420:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"product--layout--columnar":"product_product--layout--columnar__NiSjf","product__content":"product_product__content__udV3j","product__gallery":"product_product__gallery__CVK0d","product__info":"product_product__info__A2gih","product__sidebar":"product_product__sidebar__UIWxu","product__footer":"product_product__footer__O_lf8","product__wishlist-compare":"product_product__wishlist-compare__rTpMp","product__name":"product_product__name__ZZE__","product__description":"product_product__description__c4cMk","product__features":"product_product__features__htBYF","product__meta":"product_product__meta__fRugS","product__meta-availability":"product_product__meta-availability__Szl8P","product__share-links":"product_product__share-links__5JxEN","product__prices":"product_product__prices___bME7","product__new-price":"product_product__new-price__fFvCI","product__quantity":"product_product__quantity__8n_CV","product__actions":"product_product__actions__jZdoG","product__actions-item--addToCart":"product_product__actions-item--addToCart__Lixrk","btn":"product_btn__2zTGI","product__actions-item--wishlist":"product_product__actions-item--wishlist__plklZ","product__actions-item--compare":"product_product__actions-item--compare__YHDI7","product__availability":"product_product__availability__2eRhE","product__option":"product_product__option__8m9lj","product__actions-item":"product_product__actions-item__PQUVc","socialLinksBox":"product_socialLinksBox__ggwFD","active-title":"product_active-title__S14Hh","desc-heade-title":"product_desc-heade-title__Aa3Ne","label-attr__code":"product_label-attr__code__PAQ_f","other-radio__input":"product_other-radio__input__hAZGe","other-list-main-fms":"product_other-list-main-fms__6eCpB","attr_space":"product_attr_space__8c5sp","attr_label_size":"product_attr_label_size__Lh2_g","filter-color__item":"product_filter-color__item___VJoz","d-block":"product_d-block__dsLYN","btn-wrapper":"product_btn-wrapper__eKrRF","product__rating":"product_product__rating__paqGx","product__rating-stars":"product_product__rating-stars__KMgNh","product__rating-legend":"product_product__rating-legend__8upbu","text-success":"product_text-success__vimzO","text-danger":"product_text-danger__U7duD","product_price_html":"product_product_price_html__qT_sO","product__old-price":"product_product__old-price__8j0DP","product__option-label":"product_product__option-label__tEVha","product__tags":"product_product__tags__seocH","product--layout--sidebar":"product_product--layout--sidebar__SsFwX","product--layout--quickview":"product_product--layout--quickview__P_Sfi","product_attributes":"product_product_attributes__67_DA","attr_fms":"product_attr_fms__Hs6mA","attr_color_fms":"product_attr_color_fms__gAq__","color-attr_fm":"product_color-attr_fm__up0jk","other-attr_fm":"product_other-attr_fm____fb0","product--layout--standard":"product_product--layout--standard__Y1Jdg","input-check-color__body":"product_input-check-color__body__PtAyR","other-list__item":"product_other-list__item__C5P4S","other-list__title":"product_other-list__title__5LPct","other-list__input":"product_other-list__input__ZTvFk","product-inner-quantity":"product_product-inner-quantity__rFLAA","product-inner-long-description":"product_product-inner-long-description__etAmV","d-none":"product_d-none__U99Rw","d-flex":"product_d-flex__ozpFT","input-number__input":"product_input-number__input__j0nvY","inner-addToCart":"product_inner-addToCart__OrYbT","cart-quantity-responsive":"product_cart-quantity-responsive__FVN4t","button_disabled":"product_button_disabled__CtvY5","short-description":"product_short-description__d_grQ","short_description_block":"product_short_description_block__Ek6i9","rounded-pills":"product_rounded-pills__PT3gW","data-title-mob":"product_data-title-mob__scXsZ","product-inner-description-content":"product_product-inner-description-content__2kGF9","product-inner-description-title":"product_product-inner-description-title__In70t","product-inner-long-description-click":"product_product-inner-long-description-click__UycrN","liked-button-wrapper":"product_liked-button-wrapper__SMJt2","btn-light":"product_btn-light__FzzV6","btn-svg-icon--fake-svg":"product_btn-svg-icon--fake-svg__XK_Gw","tab_buttons":"product_tab_buttons__Vjvxn","tab":"product_tab__ZCT4p","tab_description":"product_tab_description__cYNDS","tab_description-active":"product_tab_description-active__9oAwA","tab_detail-active":"product_tab_detail-active__vPxic","only_one":"product_only_one__W_YvN","details_block":"product_details_block__ZGhzn","detail_row":"product_detail_row__WcPBn","detail_key":"product_detail_key__pzI4W","detail_value":"product_detail_value__AMk1B","detail_value_open":"product_detail_value_open__zxif8","detail_content":"product_detail_content__tL61K","icon_for_open":"product_icon_for_open__TzCj9","read_more":"product_read_more__BmtRz","active":"product_active__m6Wwe","mobile-buttons-config":"product_mobile-buttons-config__CzM6v","product-card__prices":"product_product-card__prices__q_2Qk","product-card__old-price":"product_product-card__old-price__wRjyg"};

/***/ }),

/***/ 97550:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"products_sort":"shop_products_sort__Qf2sl","bundle-radio-products":"shop_bundle-radio-products___DQba","bundle-multyselect-body-fm":"shop_bundle-multyselect-body-fm__p3Emz","input-radio__body":"shop_input-radio__body__Uz5BA","custom-address-min-height":"shop_custom-address-min-height__3r6Xt","bundle-input-fm":"shop_bundle-input-fm__tXiaZ","input-radio__input":"shop_input-radio__input__ohT2U","bundle-product-image-fm":"shop_bundle-product-image-fm__vKoGI","checkbox-style":"shop_checkbox-style__kQ15Z","styled-checkbox":"shop_styled-checkbox__kgwRH","img_wrapper":"shop_img_wrapper__hr8ve","img_span":"shop_img_span__A9naN","cart__link":"shop_cart__link__dcZDg","product-image__img":"shop_product-image__img__ro_5d","owl-carousel":"shop_owl-carousel__Uv6zf","owl-item":"shop_owl-item__XIhI7","product-small-img":"shop_product-small-img__w8YJ1","bundle-product-name-fm":"shop_bundle-product-name-fm__90omd","bundle-product-price-fm":"shop_bundle-product-price-fm__Mk7HH","bundle-quantity-fm":"shop_bundle-quantity-fm__fJYzy","bundle-chekbox-body-fm":"shop_bundle-chekbox-body-fm__b5UTV","product__quantity-bundle-fm":"shop_product__quantity-bundle-fm__EEgim","bundle-filters-fm":"shop_bundle-filters-fm__N_yvH","bundle-border":"shop_bundle-border__Zwy8D","bundle-title-fm":"shop_bundle-title-fm__oB5vP","bundle-multiselect":"shop_bundle-multiselect__LTju5","bundle-radio":"shop_bundle-radio__xJ7iz","bundle-title-fms":"shop_bundle-title-fms__eOwWz","h25":"shop_h25___yWFf","input-radio__circle":"shop_input-radio__circle__zdXjR","bundles-radio__circle":"shop_bundles-radio__circle__dX46k","product__actions-item":"shop_product__actions-item__QRv_R","bundle-radio-body-fm":"shop_bundle-radio-body-fm__Inz7H","bundle-select":"shop_bundle-select__npVjF","bundle-select-products":"shop_bundle-select-products__Z8gOD","bundle-select-list":"shop_bundle-select-list___6mHc","bundle-select-title-fm":"shop_bundle-select-title-fm__pHqMr","bundle-select-price-fm":"shop_bundle-select-price-fm__HMvJ4","rotT_fms":"shop_rotT_fms__8n4He","dropdown-group":"shop_dropdown-group__jCYQN","active":"shop_active__CkcV9","filter-list__list":"shop_filter-list__list__aFikf","select-products":"shop_select-products__k2PAc","checkout-card-title-fms":"shop_checkout-card-title-fms__bshlg","responsive-checkout-text":"shop_responsive-checkout-text__BUNcK","to_left":"shop_to_left__FZJOX","coupon-code":"shop_coupon-code__jmN1W","coupon-code__list":"shop_coupon-code__list__mdSu1","coupon-code-button-apply":"shop_coupon-code-button-apply__0t_Dq","tr_margin":"shop_tr_margin__EzpM4","coupon-content":"shop_coupon-content__iBqc7","coupon-content-block":"shop_coupon-content-block__givyn","checkout-card-title":"shop_checkout-card-title__m_ibV","coupon-content-block-value":"shop_coupon-content-block-value__3j3iI","rm_padding":"shop_rm_padding__fka8r","checkout__totals":"shop_checkout__totals__GOUZy","checkout__totals-products":"shop_checkout__totals-products__JV4m8","shipping-address":"shop_shipping-address__lT9Eq","checkout_billing_form_sls":"shop_checkout_billing_form_sls__FQmIC","checkout__form__block":"shop_checkout__form__block___3o5_","err-block":"shop_err-block__nGmqt","country-container__list":"shop_country-container__list__UUAkt","active_state":"shop_active_state__QdQVN","form-group":"shop_form-group__8hKBm","checkout-style":"shop_checkout-style__4E2Jq","mobile-checkout-style":"shop_mobile-checkout-style__TUp13","col-12":"shop_col-12__7wLrM","col-md-6":"shop_col-md-6__G480v","select-container":"shop_select-container__7s4EP","checkout-select":"shop_checkout-select__Vvn2w","checkout-input":"shop_checkout-input__mXf0A","custom-select-mark":"shop_custom-select-mark__lCQv5","select-dots":"shop_select-dots__UXWx6","state-error-checkout":"shop_state-error-checkout__xlVQZ","shipping-methods__item-title-fms":"shop_shipping-methods__item-title-fms__icFGc","m-right":"shop_m-right__E7Y5U","custom_input_checkout":"shop_custom_input_checkout__APGkT","payment-methods__item-title":"shop_payment-methods__item-title__0DqC_","account-details":"shop_account-details__UNw0v","part-balance":"shop_part-balance__mlj4V","list-busd-current-value":"shop_list-busd-current-value__IQ0NO","busd-value":"shop_busd-value__k3f26","crypto-list":"shop_crypto-list__PecLH","btn-web3":"shop_btn-web3__cF6P_","buttons-config-web3":"shop_buttons-config-web3__urqpY","approve_btn":"shop_approve_btn__RyK90","parent-section-connect-wallet":"shop_parent-section-connect-wallet__gLUQC","block-sidebar--position--end":"shop_block-sidebar--position--end__swJrO","block-sidebar--offcanvas--always":"shop_block-sidebar--offcanvas--always__uRtmA","block-sidebar__backdrop":"shop_block-sidebar__backdrop__rJYrk","block-sidebar__body":"shop_block-sidebar__body__eF3Is","block-sidebar__header":"shop_block-sidebar__header__OQLsi","block-sidebar--open":"shop_block-sidebar--open__pZXlA","block-sidebar--offcanvas--mobile":"shop_block-sidebar--offcanvas--mobile__aVv3Y","filter__item":"shop_filter__item__3tMw8","open":"shop_open__EhJeM","block-sidebar__title":"shop_block-sidebar__title___GfWq","tablet":"shop_tablet__HQk4_","block-sidebar__item":"shop_block-sidebar__item__LEQXx","stripe-container":"shop_stripe-container__LHpF3","stripe-container-header":"shop_stripe-container-header__h0OzS","stripe-container-header__form":"shop_stripe-container-header__form__LD1s7","stripe-container-header__form-items":"shop_stripe-container-header__form-items__og_lt","stripe-container-header__form-items-container":"shop_stripe-container-header__form-items-container__qC60K","stripe-container-header__form-items-card__cvv":"shop_stripe-container-header__form-items-card__cvv__QcGqT","stripe-container-header__form-items-card__cvv-block":"shop_stripe-container-header__form-items-card__cvv-block___79jR","credit_card":"shop_credit_card__lDIJJ","card__cvv-element":"shop_card__cvv-element__qdQTd","stripe-container-header__form-items-card__number":"shop_stripe-container-header__form-items-card__number__S_3Yy","card":"shop_card__TOKEn","stripe-container-header__form-items-card__number-title":"shop_stripe-container-header__form-items-card__number-title__VQtJ1","products-list__item":"shop_products-list__item__D6YeC","product-card":"shop_product-card__TA6oy","products-list":"shop_products-list__lCqzS","product-card__description":"shop_product-card__description__Hko1O","product-card__availability":"shop_product-card__availability__BCJLF","product-card__features-list":"shop_product-card__features-list__Lhx63","product-card__buttons":"shop_product-card__buttons__Ye9sf","btn":"shop_btn__Rrwv6","btn-svg-icon":"shop_btn-svg-icon__kXA2C","product-card__badges-list":"shop_product-card__badges-list__QNAOK","product-card__name":"shop_product-card__name__lJChy","product-card__rating":"shop_product-card__rating__p6oKV","product-card__prices":"shop_product-card__prices__j2y6M","product-card__old-price":"shop_product-card__old-price__5r13B","product-card__addToCart":"shop_product-card__addToCart__Hz__c","product-card__addToCart--list":"shop_product-card__addToCart--list__k8vEt","product-card__wishlist":"shop_product-card__wishlist__49sCD","product-card__compare":"shop_product-card__compare__mkTnT","found-product-card":"shop_found-product-card__fgkyF","products-view":"shop_products-view__zrv7W","products-view--loading":"shop_products-view--loading__9waBJ","products-view__loader":"shop_products-view__loader__4x_DC","view-options":"shop_view-options__vKzBX","view-options--offcanvas--mobile":"shop_view-options--offcanvas--mobile__dWEdK","view-options__filters-button":"shop_view-options__filters-button__PhHuV","products-list__body":"shop_products-list__body__qy2YV","shop-layout__content":"shop_shop-layout__content__ATia7","products-view__empty":"shop_products-view__empty__Lh510","products-view__empty-title":"shop_products-view__empty-title__mn_Eo","products-view__empty-subtitle":"shop_products-view__empty-subtitle__BlNsU","text-center":"shop_text-center__ilTRb","search-loading-empty":"shop_search-loading-empty__WWfK9","block-loader__spinner":"shop_block-loader__spinner__1O7_U","preloader-animation":"shop_preloader-animation__4OsT_","card-title-met-fms":"shop_card-title-met-fms__2_AD5","chakout-radio-titles":"shop_chakout-radio-titles__pyJMf","product-image__body":"shop_product-image__body__Ud6WV","img_btn_wrapper":"shop_img_btn_wrapper__GFvvf","checkout-shipimg-title-fms":"shop_checkout-shipimg-title-fms__gr1GB","cart__checkout-button":"shop_cart__checkout-button__HmI6E","cart__totals-td":"shop_cart__totals-td__bf_BM","del-icon-fms":"shop_del-icon-fms__DTCXK","delete-btn-position":"shop_delete-btn-position__X_ofw","cart-table__row":"shop_cart-table__row__ZZVPC","product-card__new-price":"shop_product-card__new-price__WIk3D","cart-table__product-name":"shop_cart-table__product-name__EErCg","cart-table__column--total":"shop_cart-table__column--total__kAWJ2","cart-table__column--price":"shop_cart-table__column--price__iJAnR","cart-table__column--quantity":"shop_cart-table__column--quantity__cZuMs","delete-btn_shipping":"shop_delete-btn_shipping__836lO","cart-table__column-fm":"shop_cart-table__column-fm__CZC_j","order-list__column-image":"shop_order-list__column-image__PeAW6","product-image":"shop_product-image__clT3I","product-gallery__featured":"shop_product-gallery__featured__D7DzF","cart-table__column--image":"shop_cart-table__column--image__KhdKG","wishlist-card-image":"shop_wishlist-card-image__caN2x","product-gallery__carousel-item--active":"shop_product-gallery__carousel-item--active__MP2jk","product-image--location--gallery":"shop_product-image--location--gallery__DZ9_g","cart-table__options":"shop_cart-table__options__CBxgp","full_block":"shop_full_block__YW2Yq","block":"shop_block__RfYPw","filter_wrapper":"shop_filter_wrapper__zSK_s","empty_block":"shop_empty_block___IMcv","category_components_wrapper":"shop_category_components_wrapper__ZGsLI","cart-page-container":"shop_cart-page-container__zp396","cart-table":"shop_cart-table__QI0Ew","cart__actions":"shop_cart__actions__Td6zV","cart__buttons":"shop_cart__buttons__cMeeU","continue--arrow":"shop_continue--arrow___pOwt","continue-shopping-title":"shop_continue-shopping-title__79YJ_","chekout-total-fms":"shop_chekout-total-fms__hkZ8b","block-empty":"shop_block-empty__PVK_e","block-empty__body":"shop_block-empty__body__wKioz","block-empty-fms":"shop_block-empty-fms__ZMnfV","block-empty__actions":"shop_block-empty__actions__kBxie","shopping-cart-text":"shop_shopping-cart-text__wWWht","widget-categories":"shop_widget-categories__y7dta","shop-layout__sidebar":"shop_shop-layout__sidebar__Q1Ebd","shop-layout--sidebar--start":"shop_shop-layout--sidebar--start__TYwKD","shop-layout--sidebar--end":"shop_shop-layout--sidebar--end__E9egf","category-title":"shop_category-title___mXCp","category-description":"shop_category-description__lOpxO","shop-layout":"shop_shop-layout__3vZId","block-fms":"shop_block-fms__qkjDo","posts-view__pagination":"shop_posts-view__pagination__8QMGp","payment-methods__item":"shop_payment-methods__item__wo1vw","payment-methods__item-header":"shop_payment-methods__item-header__QwO97","payment-methods__item-radio":"shop_payment-methods__item-radio__oF7oK","input-radio":"shop_input-radio__l1y4n","payment-methods__item-container":"shop_payment-methods__item-container__sC5Du","payment-methods__item--active":"shop_payment-methods__item--active__Fqcyi","payment-methods":"shop_payment-methods__kD4s4","payment-method-title":"shop_payment-method-title__lACs0","payment-methods__list":"shop_payment-methods__list__XVfll","checkout":"shop_checkout__6RNJ6","checkout-page-title":"shop_checkout-page-title__GnGea","row":"shop_row__QzIr0","main_checkout_row":"shop_main_checkout_row__zHxKs","checkout_form_group":"shop_checkout_form_group__U2Dua","already-have-account-fms":"shop_already-have-account-fms__4ehOk","already-have-account-responsive":"shop_already-have-account-responsive__09Pj8","link-underline":"shop_link-underline__TpQL9","input-check__input":"shop_input-check__input__RLRBS","input-check__box":"shop_input-check__box__eqN3H","input-check__icon":"shop_input-check__icon__yoXqa","card-body-fms":"shop_card-body-fms__6dmIn","btn-loading":"shop_btn-loading__ROitP","checkout__agree":"shop_checkout__agree__U6uiE","form-check":"shop_form-check__EgB9G","form-check-input":"shop_form-check-input__iUMYh","form-check-label":"shop_form-check-label__uHQ7b","agree-privacy-text":"shop_agree-privacy-text__K2vJA","privacy-fms":"shop_privacy-fms__1OO1O","custon-btn-padding":"shop_custon-btn-padding__KSDvz","popUpwrapper":"shop_popUpwrapper__76URV","popUp":"shop_popUp__S_9ov","close-wrapper":"shop_close-wrapper__y23_M","popUp-content":"shop_popUp-content__oj_hr","product-card-parent":"shop_product-card-parent__S7oxT","block-products__list-item":"shop_block-products__list-item__THtjX","wishlist__body":"shop_wishlist__body__po7wt","wishlist__column":"shop_wishlist__column__qKM4Y","wishlist__row":"shop_wishlist__row__ND_Rc","already-have-account-mail-fms":"shop_already-have-account-mail-fms__T_UxD","MuiTextField-root":"shop_MuiTextField-root__Oy8SQ","cart-table__column--remove":"shop_cart-table__column--remove__jN2u_","category-container":"shop_category-container__U1otu","wishlist-container":"shop_wishlist-container__sCD4q","wishlist":"shop_wishlist__BNHh1","cart-table__body":"shop_cart-table__body__6jdgM","cart-table__column":"shop_cart-table__column__OILNd","cart-table__head":"shop_cart-table__head__5UVmv","checkout-select-billing":"shop_checkout-select-billing__JMesK","cart-table__column--product":"shop_cart-table__column--product__j2euh","data-title-mob":"shop_data-title-mob__Rn33u","column--total-fms":"shop_column--total-fms__7cLmn","d-none":"shop_d-none__Ht2eN","crossel_body":"shop_crossel_body__ho3uG","product-card__image":"shop_product-card__image__dpmb3","product-inner-quantity":"shop_product-inner-quantity__goToF","account-addres-list":"shop_account-addres-list___aixl","remove_btn":"shop_remove_btn__lfnHm","total-pr-fms":"shop_total-pr-fms__sRvXY"};

/***/ })

}]);